/**
 * På mobil ligger sidans rullning i en egen behållare (#app-scroll) så att
 * header och tabbar kan sitta fast kant i kant. På desktop scrollar fönstret
 * som vanligt. Hjälparna nedan gör att scroll-kod fungerar i båda lägena.
 */

export const APP_SCROLL_ID = "app-scroll";

/** Returnerar behållaren som faktiskt rullar, eller null om det är fönstret. */
export function getAppScroller(): HTMLElement | null {
  if (typeof document === "undefined") return null;
  const el = document.getElementById(APP_SCROLL_ID);
  if (!el) return null;
  const style = window.getComputedStyle(el);
  const scrolls = style.overflowY === "auto" || style.overflowY === "scroll";
  return scrolls ? el : null;
}

/** Nuvarande scrollposition, oavsett om det är fönstret eller behållaren. */
export function getScrollTop(): number {
  return getAppScroller()?.scrollTop ?? window.scrollY;
}

/** Scrollar så att elementet hamnar `offset` px från toppen. */
export function scrollToElement(el: Element, offset = 0) {
  const scroller = getAppScroller();
  if (scroller) {
    const top =
      el.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop - offset;
    scroller.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    return;
  }
  const top = el.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
}
